import React from "react";
import SalesIcon from "../../assets/icons/SalesIcon.png";
import MarketingIcon from "../../assets/icons/MarketingIcon.png";
import HRIcon from "../../assets/icons/HRIcon.png";
import FinanceIcon from "../../assets/icons/FinanceIcon.png";
import ProcurementIcon from "../../assets/icons/ProcurementIcon.png";
import ProjectIcon from "../../assets/icons/ProjectIcon.png";
import FeatureArrow from "../../assets/icons/FeatureArrow.png"; 
import NextArrow from "../../assets/icons/Nextarrow.png";
import PrevArrow from "../../assets/icons/Prevarrow.png"; 
import { Button } from "@mui/material";
import { DeptArrowButton, DeptButtonWrapper, DeptCard, DeptCardContainer, DeptCardHeader, DeptDescription, DeptFeatureDivider, DeptFeatureIcon, DeptFeatureItem, DeptFeatureList, DeptFeatureTitle, DeptIcon, DeptMobileCardContainer } from "../../assets/styles/HomeStyles";
import { useNavigate } from 'react-router-dom';

const cardsData = [
  {
    title: "Sales",
    icon: SalesIcon,
    description: "Devia: Your all-in-one platform offering 360-degree visibility into critical parameters, from on-ground verification to the financial credibility of your trusted partners.",
    features: ["Pick Your Reliable Partners", "Financial Stability", "Field Assessment"],
    path: "/sales",
  },
  {
    title: "Marketing",
    icon: MarketingIcon,
    description: "Track loyalty program success and provide actionable insights to the marketing team through feedback.",
    features: ["Evaluate Your Loyalty Programs", "Feedback Assessment", "Dashboard and Analytics"],
    path: "/marketing",
  },
  {
    title: "Human Resources",
    icon: HRIcon,
    description: "From senior executives to middle management, evaluate cultural fit and performance. Tailored background checks which cover every role from blue-collared to white-collared employees.",
    features: ["Employee Background Checks", "Discreet Checks", "Audited Reports and Real-Time Updates"],
    path: "/hr",
  },
  {
    title: "Finance",
    icon: FinanceIcon,
    description: "Get started by accessing your document vault, tailored for all the departments, and customize your risk checklist to fit your needs.",
    features: ["Integrated Platform", "StepIn, Upload, and Transform", "Customer Risk Score"],
    path: "/finance",
  },
  {
    title: "Procurement",
    icon: ProcurementIcon,
    description: "Control off-contract spending and ensure deliverables by enabling vendor selection with customized scorecards.",
    features: ["Supplier Selection", "Conquer-ff Contract Spends", "Supplier Performance Measurement"],
    path: "/procurement"
  },
  {
    title: "Project Management",
    icon: ProjectIcon,
    description: "Get instant KYC reports for your business partners. Also, continuous monitoring with real-time alerts for the triggers and data set combination customized by you.",
    features: ["Instant KYC Insights", "Custom Filters & Triggers", "Proactive Monitoring and Alerts"],
    path:"/project-management"
  },
];

const CustomNextArrow = ({ onClick }) => (
  <DeptArrowButton src={NextArrow} onClick={onClick} style={{ right: "8vw" }} />
);

const CustomPrevArrow = ({ onClick }) => (
  <DeptArrowButton src={PrevArrow} onClick={onClick} style={{ left: "8vw" }} />
);

const DepartmentCards = ({ departmentsRef }) => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    console.log("Navigating to:", path);  
    navigate(path);
    window.scrollTo(0, 0);
  };
  const settings = {
    centerPadding: "50px",
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
  };

  return (
    <div ref={departmentsRef} id="departments">
      <DeptCardContainer>
        {cardsData.map((card, index) => (
          <DeptCard key={index}>
            <DeptCardHeader>
              <DeptIcon src={card.icon} alt={card.title} />
              {card.title}
            </DeptCardHeader>
            <DeptDescription>{card.description}</DeptDescription>
            <DeptFeatureDivider />
            <DeptFeatureTitle>Features</DeptFeatureTitle>
            <DeptFeatureList>
              {card.features.map((feature, idx) => (
                <DeptFeatureItem key={idx}>
                  <DeptFeatureIcon src={FeatureArrow} alt="Arrow" />
                  {feature}
                </DeptFeatureItem>
              ))}
            </DeptFeatureList>
            <DeptButtonWrapper>
              <Button className="custom-button small-padding" variant="contained"  onClick={() => handleNavigate(card.path)} >
                Know More
              </Button>
            </DeptButtonWrapper>
          </DeptCard>
        ))}
      </DeptCardContainer>

      <DeptMobileCardContainer {...settings}>
        {cardsData.map((card, index) => (
          <DeptCard key={index}>
            <DeptCardHeader>
              <DeptIcon src={card.icon} alt={card.title} />
              {card.title}
            </DeptCardHeader>
            <DeptDescription>{card.description}</DeptDescription>
            <DeptFeatureDivider />
            <DeptFeatureTitle>Features</DeptFeatureTitle>
            <DeptFeatureList>
              {card.features.map((feature, idx) => (
                <DeptFeatureItem key={idx}>
                  <DeptFeatureIcon src={FeatureArrow} alt="Arrow" />
                  {feature}
                </DeptFeatureItem>
              ))}
            </DeptFeatureList>
            <DeptButtonWrapper>
              <Button className="custom-button" variant="contained"  onClick={() => handleNavigate(card.path)}>
                Get Demo
              </Button>
            </DeptButtonWrapper>
          </DeptCard>
        ))}
      </DeptMobileCardContainer>
    </div>
  );
};

export default DepartmentCards;
